import { createActionWithPayload } from './utils';

export const ACTIONS = {
  SET_AB_FLAG: 'SET_AB_FLAG',
} as const;

export interface IAbFlagPayload {
  featureKey: string;
  isEnabled: boolean;
  variant?: string;
}

export const setAbFlag = createActionWithPayload<
  typeof ACTIONS.SET_AB_FLAG,
  IAbFlagPayload
>(ACTIONS.SET_AB_FLAG);
